<template>
  <section class="delivrerylist">
    <header class="flex-container">
      <form @submit.prevent="handleSearchList(search)">
        <f-search v-model="search" class="input-search"></f-search>
      </form>
      <div class="keywords">
        <span v-for="(term, id) in terms" :key="id" class="term">
          <span>{{ term }}</span>
          <ab-icon icon="close" @click.native="removeTerm(id)"></ab-icon>
        </span>
      </div>
      <span class="flex-spacer"></span>
      <div>
        <router-link :to="{ name: 'DeliveryCreate' }" class="btn-action secondary" v-if="user.role_id != 3">Saisir bon de livraison</router-link>
      </div>
    </header>
    <main>
      <f-table>
        <template slot="colgroup">
          <col class="checkbox">
          <col>
          <col class="delivery-number">
          <col class="supplier">
          <col class="date">
          <col class="total">
          <col class="total">
          <col class="total">
          <col class="state">
          <col class="more">
        </template>
        <template slot="thead">
          <th></th>
          <th></th>
          <th>N° de BL</th>
          <th>Fournisseurs</th>
          <th>Date</th>
          <th class="right">Total livraison</th>
          <th class="right">Total avoir</th>
          <th class="right">Total facturation</th>
          <!-- <th class="right">Avoir</th> -->
          <th>Etat</th>
          <th></th>
        </template>
        <template slot="tbody">
          <tr v-for="(delivery, idx) in deliveries" :key="idx">
            <td><f-checkbox v-model="delivery.checked" :disabled="delivery.statusId != 1"></f-checkbox></td>
            <td class="attach-file"><ab-icon icon="attach-file" v-if="delivery.bill_verif !== null"></ab-icon></td>
            <td>{{ delivery.code }}</td>
            <td>{{ delivery.supplier }}</td>
            <td>{{ delivery.date | date('DD MMMM YYYY') }}</td>
            <td class="right txt-secondary">
                <div>{{ delivery.total | currency }}</div>
                <small class="txt-ternary">TTC: {{ delivery.total_ttc | currency }}</small></td>
            <td class="right txt-primary">{{ computedBillTotal(delivery.billTotalDa) }}</td>
            <td class="right txt-primary">
              <div>{{ computedBillTotal(delivery.total_bill) }}</div>
              <small class="txt-ternary">{{ computedBillTotalTTC(delivery.total_bill_ttc) }}</small>
            </td>
            <td>{{ delivery.status }}</td>
            <td>
              <f-popover-top class="tooltip-right">
                <template slot="container"><ab-icon icon="more"></ab-icon></template>
                <template slot="list">
                  <ul>
                    <li v-if="delivery.statusId == 1">
                      <router-link :to="{ name: 'DeliveryEdit', params: { id: delivery.id} }" class="item"><ab-icon icon="update"></ab-icon>Modifier</router-link>
                    </li>
                    <li v-if="delivery.statusId == 1">
                      <router-link :to="{ name: 'DeliveryAssociation', query: { delivery: delivery.id } }" class="item"><ab-icon icon="associate" iconset="delivery"></ab-icon>Rapprocher</router-link>
                    </li>
                    <li v-if="delivery.statusId == 2">
                      <router-link :to="{ name: 'DeliveryAssociationEdit', query: { delivery: delivery.id } }" class="item"><ab-icon icon="bill"></ab-icon>Clôturer / avoir reçu</router-link>
                    </li>
                    <li v-if="delivery.statusId == 1">
                      <span class="item" @click="showModal(delivery.id)"><ab-icon icon="delete"></ab-icon>Supprimer</span>
                    </li>
                    <li v-if="delivery.statusId == 3 || delivery.statusId == 4">
                      <router-link :to="{ name: 'DeliveryDetail', params: { id: delivery.id} }" class="item"><ab-icon icon="update"></ab-icon>Visualiser</router-link>
                    </li>
                  </ul>
                </template>
              </f-popover-top>              
            </td>
          </tr>
        </template>
      </f-table>
    </main>
    <footer class="flex flex-space">
        <paginate 
          v-model="currentPage"
          :pageCount="dataPageCount"
          prev-class="prev"
          next-class="next"
          :containerClass="'f-pagination'">
        </paginate>
        <div class="flex">
          <p class="select-elements-text">Nombre de ligne par page :</p>
          <f-select
            v-model="selected"
            :options="options"
            :close-on-select="true"
            :searchable="false"
            :allow-empty="false"
            :showLabels="false"
            :multiple="false"
            class="select-elements"
          >
          </f-select>
        </div>
      <div class="flex flex-right button">
        <ab-button class="primary" @click.native="showFullAssociation">Rapprochement complet</ab-button>
        <ab-button class="primary" @click.native="detailAssociation">Rapprochement détaillé</ab-button>
      </div>
    </footer>

    <!-- Association -->
    <f-modal class="association" name="association" height="auto" width="800" :scrollable="true">
      <f-card>
        <main>
          <f-table>
            <template slot="thead">
              <th>N° BDL</th>
              <th>Date de facture</th>
              <th class="mandatory-label">N° Facture</th>
              <th class="mandatory-label">Date règlement</th>
            </template>
            <template slot="tbody">
              <tr v-for="(delivery, idx) in computedDeliveries" :key="`assication-${idx}`">
                <td>{{ delivery.code }}</td>
                <td>
                  <datepicker
                    class="f-datepicker"
                    :monday-first="true"
                    v-model="delivery.billDate"
                    :language="fr"></datepicker>
                </td>
                <td class="flex flex-space">
                  <ab-input v-model="delivery.bill" class="bill" placeholder="N° facture"></ab-input>
                  <div class="file-btn">
                    <ab-icon class="upload" icon="file-upload" iconset="delivery" @click.native="handleUploadBill(delivery.id)"></ab-icon>
                    <span v-show="delivery.files && delivery.files.length" class="count">{{ delivery.files ? delivery.files.length : null }}</span>
                  </div>
                </td>
                <td>
                  <div class="flex flex-space">
                    <f-select
                    class="payment-select"
                      placeholder="Règlement"
                      trackBy="id"
                      label="label"
                      :showLabels="false"
                      :options="payments"
                      :searchable="false"
                      v-model="delivery.payment">
                    </f-select>
                    <datepicker
                      class="f-datepicker"
                      :monday-first="true"
                      placeholder="JJ/MM/AAAA"
                      :language="fr"
                      :disabled="!delivery.payment || delivery.payment.id != 1"
                      v-model="delivery.paymentDate">
                    </datepicker>
                  </div>
                </td>
              </tr>
            </template>
          </f-table>
        </main>
        <footer slot="footer" class="flex flex-right">
          <ab-button @click.native="$modal.hide('association')">Annuler</ab-button>
          <ab-button class="primary" @click.native="completeAssociation">Rapprocher</ab-button>
        </footer>
      </f-card>
    </f-modal>

    <!-- Confirm delete -->
    <f-modal class="modal" name="remove" height="auto" @before-open="beforeOpen">
      <section>
        <f-card>
          <main>
            <p>Confirmer la suppression du bon de livraison</p>
          </main>
          <footer class="flex flex-right">
            <ab-button class="white" @click.native="closeModal('remove')">Non</ab-button>
            <ab-button class="danger" @click.native="removeDelivery">Oui</ab-button>
          </footer>
        </f-card>
      </section>
    </f-modal>

    <!-- Upload files -->
    <f-modal class="modal" name="upload" height="auto">
      <section>
        <f-card>
          <main>
            <p>Télécharger une facture</p>
            <file-pond
              name="bills"
              ref="pond"
              :label-idle="pondLabel"
              :allow-multiple="true"
              :max-files="5"
              :files="files"
              :allow-file-type-validation="true"
              :accepted-file-types="pondAcceptedFileType">
            </file-pond>
          </main>
          <footer class="flex flex-right">
            <ab-button class="white" @click.native="closeModal('upload')">Fermer</ab-button>
            <ab-button class="primary" @click.native="uploadFiles">Valider</ab-button>
          </footer>
        </f-card>
      </section>
    </f-modal>
    <ab-iconset iconset="delivery">
      <g id="associate">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.2 0C7.86274 0 8.4 0.537258 8.4 1.2V4.8C8.4 5.75478 8.02072 6.67045 7.34558 7.34558C6.67045 8.02072 5.75478 8.4 4.8 8.4H1.2C0.537258 8.4 0 7.86274 0 7.2C0 6.53726 0.537258 6 1.2 6H4.8C5.11826 6 5.42348 5.87357 5.64853 5.64853C5.87357 5.42348 6 5.11826 6 4.8V1.2C6 0.537258 6.53726 0 7.2 0ZM16.8 0C17.4627 0 18 0.537258 18 1.2V4.8C18 5.11826 18.1264 5.42348 18.3515 5.64853C18.5765 5.87357 18.8817 6 19.2 6H22.8C23.4627 6 24 6.53726 24 7.2C24 7.86274 23.4627 8.4 22.8 8.4H19.2C18.2452 8.4 17.3295 8.02072 16.6544 7.34558C15.9793 6.67045 15.6 5.75478 15.6 4.8V1.2C15.6 0.537258 16.1373 0 16.8 0ZM0 16.8C0 16.1373 0.537258 15.6 1.2 15.6H4.8C5.75478 15.6 6.67045 15.9793 7.34558 16.6544C8.02072 17.3295 8.4 18.2452 8.4 19.2V22.8C8.4 23.4627 7.86274 24 7.2 24C6.53726 24 6 23.4627 6 22.8V19.2C6 18.8817 5.87357 18.5765 5.64853 18.3515C5.42348 18.1264 5.11826 18 4.8 18H1.2C0.537258 18 0 17.4627 0 16.8ZM19.2 18C18.8817 18 18.5765 18.1264 18.3515 18.3515C18.1264 18.5765 18 18.8817 18 19.2V22.8C18 23.4627 17.4627 24 16.8 24C16.1373 24 15.6 23.4627 15.6 22.8V19.2C15.6 18.2452 15.9793 17.3295 16.6544 16.6544C17.3295 15.9793 18.2452 15.6 19.2 15.6H22.8C23.4627 15.6 24 16.1373 24 16.8C24 17.4627 23.4627 18 22.8 18H19.2Z"/>
      </g>
      <g id="file-upload"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path></g>
    </ab-iconset>
  </section>
</template>

<script>
import FTable from '@/components/layout/table/f-table.vue';
import FCard from '@/components/layout/card/f-card.vue';
import FPopoverTop from '@/components/modal/popover/f-popover-top.vue';
import FSearch from '@/components/form/input/f-search.vue';
import AbIcon from '@/components/icon/ab-icon.vue';
import FCheckbox from '@/components/form/input/f-checkbox.vue';
import AbButton from '@/components/form/button/ab-button.vue';
import AbInput from '@/components/form/input/ab-input.vue';
import Paginate from 'vuejs-paginate';
import { mapState } from 'vuex';
import paginationMixin from '@/components/mixins/pagination.js';
import searchMixin from '@/components/mixins/search.js';
import AbIconset from '@/components/icon/ab-iconset.vue';
import Datepicker from 'vuejs-datepicker';
import { fr } from 'vuejs-datepicker/dist/locale';
// Import error message files
import messages from '@/messages/messages.js';
import notification from '@/components/mixins/notification.js';
// Import FilePond
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  name: 'DeliveryList',
  mixins: [ paginationMixin, searchMixin, notification ],
  components: {
    FSearch, 
    FCard,
    FTable,
    FCheckbox,
    FPopoverTop,
    AbButton,
    AbInput,
    AbIconset,
    AbIcon,
    Paginate,
    FilePond,
    Datepicker
  },
  data() {
    return {
      deliveryId: '',
      search: '',
      files: [],
      pondLabel: "Glissez vos documents ou <u>cliquez ici</u>",
      pondAcceptedFileType: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'],
      fr:fr,
      selected: 15,
      options: [15, 30, 50, 100, 200],
      dataPageCount: 1
    }
  },
  computed: {
    ...mapState([ 'client' ]),
    ...mapState({ user: state => { return state.user } }),
    ...mapState({ deliveries: state => state.deliveries.deliveries }),
    ...mapState({ pagecount: state => state.deliveries.pagecount }),
    ...mapState({ payments: state => state.deliveries.payments }),
    computedDeliveries() {
      return this.deliveries.map(delivery => {
        this.$set(delivery, 'billDate', new Date(delivery.date));
        return delivery;
      }).filter(delivery => delivery.checked)
    },
  },
  methods: {
    getData(isNewSearch) {
      this.currentPage = isNewSearch ? 1 : this.currentPage;
      if (this.client) {
        this.$store.dispatch('getPayments');
        this.$store.dispatch('getDeliveries', { terms: this.terms, client: this.client, page: this.currentPage, limit: this.selected });
        this.$store.dispatch('getPageCount', { client: this.client, limit: this.selected })
        this.dataPageCount = this.pagecount;
        this.currentPage = this.$route.query.page > this.pagecount ? this.pagecount : this.currentPage;
      }
    },
    totalDelivery(products) {
      return products.map(product => product.price*product.quantity).reduce((a, b) => a + b)._toFixed(2);
    },
    computedBillTotal(total) {
      return total ? this.$options.filters.currency(total) : '-';
    },
    computedBillTotalTTC(total) {
      return total ? `TTC: ${this.$options.filters.currency(total)}` : '';
    },
    _checkSupplier() {
      let differentSupplier = false;
      for (let index = 1; index < this.computedDeliveries.length; index++) {
        const element = this.computedDeliveries[index];
        const prevElement = this.computedDeliveries[index-1];
        differentSupplier = element.supplierId != prevElement.supplierId
      }
      return differentSupplier;
    },
    _checkState() {
      return this.computedDeliveries.map(delivery => delivery.statusId).reduce((a, b) => a == b);
    },
    detailAssociation() {
      const differentSupplier = this._checkSupplier();
      if (differentSupplier) return this.displayToast({ message: messages.deliveries.DeliveryList.custom.differentSupplier, mode: 'error' });
      if (!this.computedDeliveries.length) return this.displayToast({ message: messages.deliveries.DeliveryList.custom.nothingSelected, mode: 'error' });
      const differentState = this._checkState();
      if (!differentState) return this.displayToast({ message: messages.deliveries.DeliveryList.custom.differentState, mode: 'error' });
      this.$router.push({ name: 'DeliveryAssociation', query: { delivery: this.computedDeliveries.map(delivery => delivery.id) } });
    },
    showFullAssociation() {
      if (!this.computedDeliveries.length) return this.displayToast({ message: messages.deliveries.DeliveryList.custom.nothingSelected, mode: 'error' });
      this.$modal.show('association');
    },
    async completeAssociation() {

      // Check if all bills code & payments are filled
      if (this.computedDeliveries.length) {
        for (const delivery of this.computedDeliveries) {
          if (!delivery.bill || !delivery.payment) return this.displayToast({ message: messages.deliveries.DeliveryList.custom.mandatory, mode: 'error' });
        }
      }

      const formData = new FormData();
      const deliveries = this.computedDeliveries.map(delivery => {
        if (delivery.files) {
          delivery.files.forEach(file => {
            formData.append(delivery.id, file.file, file.file.name);
          });
        }
        return {
          supplier: delivery.supplierId,
          date: new Date(delivery.billDate).getTime(),
          code: delivery.bill,
          delivery_form: delivery.id,
          payment: delivery.payment,
          payment_date: delivery.paymentDate
        };
      });
      formData.append('data', JSON.stringify(deliveries));
      const data = await this.$store.dispatch('createFullAssociation', { client: this.client, deliveries: formData });
      if (data) {
        const deliveryIds = this.computedDeliveries.map(delivery => delivery.id);
        const deliveries = {
          delivery_form: deliveryIds
        };
        await this.$store.dispatch('closeDelivery', { client: this.client, delivery: deliveries, page: this.currentPage, limit: 10  });

        this.getData();
        this.$modal.hide('association');
        this.displayToast({ message: messages.deliveries.DeliveryList.custom.association });
      } else {
        this.displayToast({ message: messages.deliveries.DeliveryList.custom.error, mode: 'error' });
      }
    },
    handleUploadBill(id) {
      this.deliveryId = id;
      const delivery = this.deliveries.find(item => item.id == id);
      if (delivery.files) {
        this.files = delivery.files;
      }
      this.$modal.show('upload');
    },
    uploadFiles() {
      const id = this.deliveryId;
      const delivery = this.deliveries.find(function(e) {return e.id == id; });
      delivery.files = this.$refs.pond.getFiles();
      this.deliveryId = '';
      this.closeModal('upload');
      this.files = [];
    },
    showModal(id) {
      this.$modal.show('remove', { id: id });
    },
    beforeOpen(e) {
      this.deliveryId = e.params.id;
    },
    closeModal(modal) {
      this.deliveryId = '';
      this.files = [];
      this.$modal.hide(modal);
    },
    async removeDelivery() {
      if (this.client) {
        const data = await this.$store.dispatch('deleteDelivery', {
          clientId: this.client,
          deliveryId: this.deliveryId,
          page: this.currentPage,
        });
        if (data) {
          this.displayToast({ message: messages.deliveries.DeliveryList.custom.success });
        } else {
          this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.error, mode: 'error' });
        }
      }
      this.$modal.hide('remove');
      this.deliveryId = "";
    },
    /* search mixin */
    searchList() {
      let isNewSearch = false;
      const terms = this.$route.query.terms || [];
      if (this.search) isNewSearch = terms.indexOf(this.search) == -1;
       this.getData(isNewSearch);
       this.search = '';
    },
  }
};
</script>

<style scoped>
/* Header */
.flex-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
header { margin-bottom: 1.1rem; }
footer { margin-top: 1.1rem; }
.input-search {
  min-width: 23rem;
  width: 23rem;
}
.f-table .right { text-align: right; }
col.checkbox { width: 1%; }
.attach-file { padding: 1rem 0; color: var(--app-primary-color); }
col.delivery-number { width: 10%; }
col.supplier { width: 17%; }
col.date { width: 16%; }
col.total { width: 20%; }
col.state { width: 15%; }
col.more { width: 1%; }

/* Payment select style */
.payment-select { width: 11rem; }

.button .ab-button { margin-right: 1rem; }
.association .f-table { box-shadow: 0 0; }
.association .f-card { padding: 0; }
.association .f-card footer { padding: 1.39rem; }
.association .f-card footer .ab-button:first-child { margin-right: 1rem; }
.f-popover-top .item { white-space: nowrap; }
.association .bill { width: 100%; }
.association .upload { cursor: pointer; }

.txt-primary {
  font-weight: 600;
  color: var(--app-primary-color);
}
.txt-secondary {
  font-weight: 600;
  color: var(--app-secondary-color);
}
.txt-ternary {
  font-weight: 600;
  font-style: italic;
  letter-spacing: 1px;
}
/* Footer */
.select-elements {
  margin-left: 2em;
  min-width: 5rem;
  max-width: 5rem;
}
.select-elements-text {
  min-width: 65%;
}
</style>
<style>
.v--modal-overlay .v--modal-box { overflow: visible; }
</style>
<style src="@/assets/styles/filepond.css"></style>
<style src="@/assets/styles/chips.css"></style>
<style src="@/assets/styles/pagination.css"></style>
<style src="@/assets/styles/datepickers.css"></style>
